import React from 'react';
import '../styles/Technology.scss';

const Technology = () => {
    return (
        <section id="technology" className="technology">
            <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="tech-content">
                    <h2>Advanced Propulsion</h2>
                    <p>Our ships utilize next-gen ion drives, cutting travel time to Mars by 60%. Sustainable, silent, and safe.</p>
                    <div className="stats">
                        <div className="tech-stat">
                            <h3>0.2c</h3>
                            <span>Max Speed</span>
                        </div>
                        <div className="tech-stat">
                            <h3>99.9%</h3>
                            <span>Efficiency</span>
                        </div>
                    </div>
                </div>
                <div className="tech-visual">
                    <div className="reactor-core"></div>
                </div>
            </div>
        </section>
    );
};

export default Technology;
